import React from "react";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { useAuth0 } from "@auth0/auth0-react";

// Create a styled button with enhanced appearance
const StyledLoginButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#3a1a5a', // Dark purple to match the login page background
  color: 'white',
  padding: '12px 30px',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  borderRadius: '28px',
  textTransform: 'none', // Prevents all caps
  boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .3)',
  '&:hover': {
    backgroundColor: '#2a1140', // Darker shade of the same purple on hover
    boxShadow: '0 5px 8px 2px rgba(0, 0, 0, .4)',
  },
  transition: 'all 0.3s ease-in-out',
}));

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  return (
    <StyledLoginButton 
      onClick={() => loginWithRedirect()}
      variant="contained"
      size="large"
    >
      Log In
    </StyledLoginButton>
  );
};

export default LoginButton;